import {
  LinkBox,
  Box,
  Heading,
  LinkOverlay,
  Text,
  HStack,
  VStack,
  Button,
  Image,
  Icon
} from '@chakra-ui/react'
import React, { useContext, useState } from 'react'
import toast from 'react-hot-toast'
import { BiLogOut } from 'react-icons/bi'
import { Link as RouterLink } from 'react-router-dom'
import { Layout } from '../../components'
import { ROUTES } from '../../contants'
import { AuthContext, LOGOUT } from '../../context/auth/index.js'
import { Axios } from '../../utils'

const Settings = () => {
  const { dispatch } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)

  const logout = async () => {
    setLoading(true)
    // const notification_token = localStorage.getItem('notification_token') || ''
    // if (notification_token) {
    //   await Axios.delete('/device', { data: { notification_token } })
    // }
    dispatch({ type: LOGOUT })
    toast.success('Successfully Logged Out.')
    localStorage.clear()
    setLoading(false)
  }

  return (
    <Layout noMb title="Settings">
      <VStack flex={1} spacing={0} w="full">
        {Options.map((item, index) => (
          <SettingLink key={item.icon} index={index} {...item} />
        ))}
      </VStack>
      <Button
        leftIcon={<Icon h="1.8rem" w="2rem" as={BiLogOut} />}
        colorScheme="red"
        bg="red.100"
        isLoading={loading}
        onClick={logout}
        _hover={{ bg: 'red.200' }}
        _active={{ bg: 'red.200' }}
        _focus={{ bg: 'red.200' }}
        color="#FF1B1B">
        Logout
      </Button>
    </Layout>
  )
}

export { Settings }

type Props = {
  title: string
  description: string
  icon: any
  index: number
  path: string
}

const SettingLink = ({ title, description, icon, index, path }: Props) => {
  return (
    <LinkBox
      spacing="2rem"
      borderTop={index === 0 ? '1px solid #e2e1e1' : ''}
      borderBottom="1px solid #e2e1e1"
      as={HStack}
      w="full"
      alignItems="center"
      pt="0.7rem"
      pb="1.4rem">
      <Image src={`/icons/${icon}.svg`} />
      <VStack spacing="0" align="flex-start">
        <Heading fontWeight="500">
          <LinkOverlay as={RouterLink} to={path} color="black" fontSize="1.2rem" href="#">
            {title}
          </LinkOverlay>
        </Heading>
        <Text fontSize="1rem">{description}</Text>
      </VStack>
    </LinkBox>
  )
}

const Options = [
  {
    title: 'Profile',
    description: 'User Bio and Contact information',
    icon: 'profile',
    path: ROUTES.settings.profile
  },
  {
    title: 'Security',
    description: 'PIN',
    icon: 'pin',
    path: ROUTES.settings.security
  },
  {
    title: 'Claims',
    description: 'Contact information for claims',
    icon: 'claims',
    path: ROUTES.settings.claims
  },
  {
    title: 'FAQs',
    description: 'Kappa Help Resource Library',
    icon: 'faq',
    path: ROUTES.settings.faqs
  },
  {
    title: 'Privacy Policy',
    description: 'How we handle your data.',
    icon: 'policy',
    path: ROUTES.settings.privacyPolicy
  },
  {
    title: 'Terms and conditions',
    description: 'Our Terms of Service',
    icon: 'terms',
    path: ROUTES.settings.tAndC
  }
]
